/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React from 'react';
import TextField from '@material-ui/core/TextField';
import { MenuItem } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button, Dropdown } from 'react-bootstrap';
import Box from '@material-ui/core/Box';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import _ from 'lodash';
// custom SVG Icon import
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
// import custom Component
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import SelectBoxRender from './gridComponents/SelectBoxRender';
// Import custom function
import { tableGridHight350 } from '../../../../SharedModules/CommonConstants/commonConstants';
import { getInvoiceDetailsByInvoiceNum } from '../../../Display/invoice/store/actions';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';

import {
  redirectURLLink,
  handleScrollToEvent,
  closeTab,
  getCommonDropdownList,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  dispatchUnderThresholdSearch,
  getUnderThresholdSearchRecord,
  setDetailsScreenTab,
  postSaveOrUpdate,
  getRebateProgramDropdownList,
  selectedIndex,
  clearSelectedIndex
} from '../store/Actions';
import { TableHeadUnderThrInv } from './gridComponents/tableHead';
import {
  tabHighLigther,
  isReadOnly as readOnly,
} from '../../../../SharedModules/utilities/utilities';

function DisplayUnderThresholdInvoices(props) {
  const RedColor = '#a81f00';
  const dispatch = useDispatch();
  const history = useHistory();
  const intialValueHandlingCode = React.useRef()
  // use Selector function
  const loginState = useSelector(
    (state) => state?.sharedState?.SharedReducer?.loginStateStoreObj
  );
  let isReadOnly = false;
  if (loginState) {
    isReadOnly =
      readOnly(window.location.pathname, loginState)?.readOnly || false;
  }
  const detailScreenTabData = useSelector(
    (state) => state.sharedState.UnderThresholdInvoiceReducer?.detailsScreenObj
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const fetchState = useSelector(
    (state) =>
      state.sharedState.UnderThresholdInvoiceReducer?.searchScreenObj?.state
  );
  const underThresholdSearchList = useSelector((state) =>
    state.sharedState.UnderThresholdInvoiceReducer?.underThresholdSearchList?.sort(
      (a, b) => a.mfgId - b.mfgId
    )
  );
  const saveOrUpdateMessage = useSelector((state) => {
    return state.sharedState.UnderThresholdInvoiceReducer.saveOrUpdateMessage;
  });
  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer.CommentListData;
  });
  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );

  const selectedIndexSel = useSelector(
    (state) => state.sharedState.UnderThresholdInvoiceReducer.selectedIndex
  );

  // variable deceleration
  const gridRef = React.useRef();
  const [open, setOpen] = React.useState(false);
  const [flag,setFlag] = React.useState(false);
  const [openCancel, setOpenCancel] = React.useState(false);
  const [successMessages, setSuccessMessage] = React.useState([]);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const [commonDropdownList, setCommonDropdownList] = React.useState([]);
  const [disabledSaveCancelBtn, setDisabledSaveCancelBtn] =
    React.useState(true);
  const [clickOncloseTabBtn, setClickOncloseTabBtn] = React.useState(false);
  const [showComments, setShowComments] = React.useState(false);
  const [corrLinkId, setCorrLinkId] = React.useState(null);
  const [columnApi, setColumnApi] = React.useState(null);
  const [gridParams, setGridParams] = React.useState(null);
  // handing highlight tab
  React.useEffect(() => {
    if (detailScreenTabData?.errorMessages?.length > 0) {
      tabHighLigther('/viewUnderThresholdInvoice', true);
    } else {
      tabHighLigther('/viewUnderThresholdInvoice', false);
    }
  }, [JSON.stringify(detailScreenTabData)]);

  // handle all plan type get service
  React.useEffect(() => {
    handleScrollToEvent();
    getCommonDropdownList({
      codeDomainList: ['INVOICE_HANDLING_CD'],
    }).then((res) => {
      setCommonDropdownList(res);
    });
  }, []);
  // handing refresh functionality
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (detailScreenTabData && Object.keys(detailScreenTabData).length > 0) {
      const newObj = updateTabs?.map((item) => {
        if (
          item.navTo === '/viewUnderThresholdInvoice' &&
          !disabledSaveCancelBtn
        ) {
          item.isFormDirty = true;
        } else if (item.navTo === '/viewUnderThresholdInvoice')
          item.isFormDirty = false;
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [!disabledSaveCancelBtn || detailScreenTabData]);
  // set Initial state values
  React.useEffect(() => {
    if (Object.keys(detailScreenTabData)?.length === 0) {
      setDisabledSaveCancelBtn(true);
    } else {
      const tempObj = detailScreenTabData;
      setDisabledSaveCancelBtn(tempObj.disabledSaveCancelBtn);
      if (tempObj?.fullScreenView) setFullScreenView(tempObj.fullScreenView);
      if (tempObj?.successMessages) setSuccessMessage(tempObj.successMessages);
    }
  }, [detailScreenTabData]);

  // set common dropdown list after calling API service
  React.useEffect(() => {
    getRebateProgramDropdownList(fetchState?.planTypeCd).then((res) => {
      let list = [];
      if (
        res?.status === constantMessageData.STATUS_MSG &&
        res?.message === constantMessageData.SUCCESS_MSG
      ) {
        if (!_.isEmpty(res.data)) {
          list = _.map(res.data, (val) => ({
            ...val,
            id: val.rebateProgramCd,
            name: `${val.rebateProgramCd} | ${val.shortDescr}`,
          }));
        }
      }
      setRebateProgramList(
        list.sort((key, val) =>
          key.name.toLowerCase().localeCompare(val.name.toLowerCase())
        )
      );
    });
  }, [fetchState?.planTypeCd]);
  // handle after call service show success and error message
  React.useEffect(() => {
    if (saveOrUpdateMessage && saveOrUpdateMessage.message === 'SUCCESS') {
      setSuccessMessage([constantMessageData.SUCCESSMESSAGE_GENERIC]);
      dispatch(clearSelectedIndex());
      setDisabledSaveCancelBtn(true);
      dispatch(
        setDetailsScreenTab({
          disabledSaveCancelBtn: true,
          successMessages: [constantMessageData.SUCCESSMESSAGE_GENERIC],
        })
      );
      if (!clickOncloseTabBtn) {
        dispatch(postSaveOrUpdate(null));
        dispatch(setDetailsScreenTab({}));
        closeTab('/viewUnderThresholdInvoice', history, dispatch);
      }
      const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
      const newObj1 = updateTabs?.map((item) => {
        if (item.navTo === '/viewUnderThresholdInvoice') {
          item.isFormSave = false;
          item.isFormDirty = false;
          item.isFormError = false;
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj1));
      setFlag(true)
    } else if (saveOrUpdateMessage === 'failed') {
      const localErr = detailScreenTabData?.errorMessages || [];
      localErr.push({
        field: 'APIFailed',
        errorType: 'APIFailed',
        message: constantMessageData.FAILED_MESSAGE_GENERIC,
      });
      dispatch(
        setDetailsScreenTab({
          ...detailScreenTabData,
          disabledSaveCancelBtn: false,
          errorMessages: [...new Set(localErr)],
        })
      );
      handleScrollToEvent();
      setSuccessMessage([]);
      setDisabledSaveCancelBtn(false);
    }
  }, [saveOrUpdateMessage]);

  React.useEffect(()=>{
    if(flag&&Array.isArray(underThresholdSearchList)&&
    underThresholdSearchList?.length>0){
      intialValueHandlingCode.current= JSON.parse(JSON.stringify(underThresholdSearchList))
      setFlag(false)
    }
  },[flag])
  React.useEffect(()=>{
if(intialValueHandlingCode.current===undefined&&Array.isArray(underThresholdSearchList)&&
underThresholdSearchList?.length>0){
  intialValueHandlingCode.current= JSON.parse(JSON.stringify(underThresholdSearchList))
  }
  },[underThresholdSearchList])
  // check if any comment add on particular ccCommentsExist value
  React.useEffect(() => {
    if (showComments) {
      const tempObj =
        underThresholdSearchList &&
        underThresholdSearchList?.map((item) => {
          if (
            item.corrLinkId === corrLinkId &&
            commentsList &&
            commentsList.length > 0
          ) {
            item.ccCommentsExist = 1;
          } else if (item.corrLinkId === corrLinkId) {
            item.ccCommentsExist = 0;
          }
          return item;
        });
      dispatch(dispatchUnderThresholdSearch(tempObj));
      // eslint-disable-next-line no-unused-expressions
      gridParams?.api.refreshCells();
    }
  }, [commentsList]);
  // handing by default 1st row selection function
  const onGridReady = (params) => {
    setGridParams(params);
    setColumnApi(params.columnApi);
  };
  // click on filter icon after call
  const handleClearFilter = () => {
    if (gridRef && underThresholdSearchList?.length > 0) {
      gridRef.current.clearFilters();
      columnApi.applyColumnState({
        state: [{ colId: 'mfgId', sort: 'asc' }],
      });
    }
  };
  // save popup
  const openSave = (value) => {
    if (!value) {
      masterDataSave();
    } else {
      setOpen(value);
      setOpenCancel(false);
    }
  };
  const validateRequest = () => {
    const localErr = [];
    const newObj = [...underThresholdSearchList];
    for (let i = 0; i < newObj?.length; i += 1) {
      if (
        newObj[i]?.isUpdate &&
        (newObj[i]?.invoiceHandlingCd === null ||
          newObj[i]?.invoiceHandlingCd === '-1' ||
          newObj[i]?.invoiceHandlingCd === null)
      ) {
        localErr.push({
          field: 'invoiceHadingCd',
          errorType: `invoiceHadingCd${i}`,
          message: constantMessageData.HANDING_CODE_REQUIRED,
        });
        newObj[i].invoiceHandlingCdErr = true;
        dispatch(dispatchUnderThresholdSearch(newObj));
      }
    }
    if (
      newObj?.filter((x) => {
        return x.invoiceHandlingCdErr;
      }).length > 0
    ) {
      dispatch(
        setDetailsScreenTab({
          ...detailScreenTabData,
          disabledSaveCancelBtn: false,
          errorMessages: [...new Set(localErr)],
        })
      );
      return false;
    }
    if (
      !(
        newObj &&
        newObj?.filter((x) => {
          return x.invoiceHandlingCdErr;
        }).length > 0
      )
    ) {
      dispatch(
        setDetailsScreenTab({
          ...detailScreenTabData,
          disabledSaveCancelBtn: false,
          errorMessages: [],
        })
      );
      return true;
    }
  };
  // call after check all validation
  const onSubmit = (value) => {
    setClickOncloseTabBtn(value);
    if (validateRequest()) {
      setSuccessMessage([]);
      openSave(value);
    } else {
      handleScrollToEvent();
    }
  };
  // cancel popup
  const handelCancelClose = () => {
    setOpenCancel(false);
  };
  // handing save API calling
  const masterDataSave = () => {
    handelCancelClose();
    setOpen(false);
    const selectedRow = underThresholdSearchList.filter(obj =>obj.hasOwnProperty('key') &&selectedIndexSel.includes(obj['key']))
    const saveRequest = selectedRow
      ?.map((item) => {
        return {
          invoiceNum: item.invoiceNum,
          handlingCode: item.invoiceHandlingCd,
          lastUpdateUserId:
            UserDefaultValues && UserDefaultValues.lastUpdateUserId,
          mfgId:item.mfgId,
          qtr:fetchState.quarterValue,
          rebateProgramCd:fetchState.rebateProgramCd
        };
      });
      // const reversedArray = selectedIndexSel.reverse;
      const initalHandlingCodeValue = intialValueHandlingCode?.current      
      const mergedArray = saveRequest.map((dt,i)=>({
      ...dt,orgHandlingCode:initalHandlingCodeValue?.[selectedIndexSel[i]]?.invoiceHandlingCd,
      invoiceNum: initalHandlingCodeValue?.[selectedIndexSel[i]]?.invoiceNum?.toString(),

      }))


    dispatch(postSaveOrUpdate(mergedArray));
    handleScrollToEvent();
  };
  // handle close and confirm popup
  React.useEffect(() => {
    if (saveOrUpdateMessage && saveOrUpdateMessage.message === 'SUCCESS') {
      dispatch(postSaveOrUpdate(null));
      
    }
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs?.filter((x) => {
        return x.navTo === '/viewUnderThresholdInvoice' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs?.map((item) => {
        if (item.navTo === '/viewUnderThresholdInvoice' && item.isFormSave) {
          item.isFormSave = false;
          onSubmit(false);
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);
  // handing  full screen view function
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    dispatch(
      setDetailsScreenTab({
        ...detailScreenTabData,
        fullScreenView: !fullScreenView,
      })
    );
  };
  // calling view Detail page initial API
  const fetchViewDetailFunction = () => {
    handleClearFilter();
    dispatch(
      getUnderThresholdSearchRecord({
        planType: fetchState?.planType,
        rebateProgramCd: fetchState?.rebateProgramCd,
        qtr: fetchState?.quarterValue,
        allSelect: fetchState?.selectByHandingCode === 'All' ? 1 : 0,
        unSelect: fetchState?.selectByHandingCode === 'Unspecified' ? 1 : 0,
        handlingCode:
          fetchState?.selectByHandingCode === 'Selected'
            ? fetchState?.invoiceHadingCd
            : null,
      })
    );
  };
  // save popup
  const handleOpenClose = () => {
    setOpenCancel(true);
  };

  // click on cancel after call
  const handleSaveClose = () => {
    setOpen(false);
  };
  // handing reset All fields & data
  const resetAllFields = () => {
    handelCancelClose();
    fetchViewDetailFunction();
    setDisabledSaveCancelBtn(true);
    dispatch(setDetailsScreenTab({}));
    handleScrollToEvent();
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj1 = updateTabs?.map((item) => {
      if (item.navTo === '/viewUnderThresholdInvoice') {
        item.isFormSave = false;
        item.isFormDirty = false;
        item.isFormError = false;
      }
      return item;
    });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj1));
  };
  // handing Invoice Detail page redirect
  const handleViewDetailsForInvoiceDetail = async (data) => {
    await dispatch(
      getInvoiceDetailsByInvoiceNum({
        invoiceNum: data?.invoiceNum,
      })
    );
    redirectURLLink('/display-invoice', 'Display Invoice', history, dispatch);
  };

  return (
    <div
      className="tabs-container frr-underthreshold"
      data-testid="DisplayUTInvoices"
    >
      <SaveCancelPopup
        open={open}
        data-testid="savePopup"
        title="Save"
        onConfim={() => {
          masterDataSave();
        }}
        onCancel={() => {
          handleSaveClose();
        }}
      />
      <SaveCancelPopup
        open={openCancel}
        data-testid="cancelPopup"
        title="Cancel"
        onConfim={() => {
          resetAllFields();
        }}
        onCancel={() => {
          handelCancelClose();
        }}
      />
      <CustomSeparator
        parent1="Research"
        parent2="Display Under Threshold Invoices"
      />
      <DisplayErrorMessages
        errorMessages={[
          ...new Set(
            detailScreenTabData?.errorMessages?.length > 0
              ? _.map(detailScreenTabData?.errorMessages, (l) => l.message)
              : []
          ),
        ]}
      />
      {disabledSaveCancelBtn && (
        <DisplaySuccessMessages successMessages={successMessages} />
      )}
      <Spinner load={spinnerLoader} />
      {!fullScreenView && (
        <>
          <Box className="panel border-0">
            <div className="custom-check frr-underthreshold-top-search">
              <div className="form-wrapper form-wrapper-col-6">
                <div className="mui-custom-form input-md">
                  <TextField
                    id="Quarter"
                    label="Quarter"
                    fullWidth
                    disabled
                    placeholder=""
                    InputLabelProps={{ shrink: true }}
                    value={fetchState?.quarterValue}
                  />
                </div>
                <div className="mui-custom-form input-md">
                  <TextField
                    id="RebateProgram"
                    label="Rebate Program"
                    fullWidth
                    disabled
                    select
                    placeholder=""
                    inputProps={{ id: 'RebateProgram' }}
                    InputLabelProps={{ shrink: true }}
                    value={fetchState?.rebateProgramCd}
                  >
                    <MenuItem
                      key=""
                      value="-1"
                      className="frr-dropdown-blank-item"
                    />
                    {rebateProgramList && rebateProgramList?.length > 0
                      ? rebateProgramList?.map((item) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })
                      : null}
                  </TextField>
                </div>
                <div className="log-batch-detail-btn-group pt-4">
                  <div className="btn-wrapper">
                    <Button
                      className="btn btn-success btn-save"
                      data-testid="saveBtn"
                      disabled={disabledSaveCancelBtn || isReadOnly}
                      onClick={() => {
                        onSubmit(true);
                      }}
                    >
                      {' '}
                      <SVGComponent iconName="Icon-awesome-save" />
                      Save
                    </Button>
                    <Button
                      className="btn btn-cancel"
                      data-testid="cancelBtn"
                      onClick={() => handleOpenClose()}
                      disabled={disabledSaveCancelBtn || isReadOnly}
                    >
                      <SVGComponent iconName="Icon-cancel" />
                      Cancel
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </>
      )}
      <div className="panel-body FRR-custom-table tbl-manufacturer-inner frr-log_chk frr-invoiceThreshold frr-selectbox-invoice">
        {commonDropdownList?.INVOICE_HANDLING_CD?.length > 0 && (
          <TableGrid
            ref={gridRef}
            gridHeight={fullScreenView ? '70vh' : tableGridHight350}
            rowData={
              underThresholdSearchList &&
              underThresholdSearchList?.map((item) => {
                const firstDropdownVal =
                  commonDropdownList?.INVOICE_HANDLING_CD?.filter((x) => {
                    return (
                      x.codeValueID &&
                      x.codeValueID?.codeValue === item.invoiceHandlingCd
                    );
                  });
                if (firstDropdownVal && firstDropdownVal.length > 0) {
                  item.invoiceHandlingCdValWithLabel = `${
                    firstDropdownVal[0].codeValueID &&
                    firstDropdownVal[0].codeValueID.codeValue
                  } - ${firstDropdownVal[0].shortDescription}`;
                } else {
                  item.invoiceHandlingCdValWithLabel = null;
                }
                return item;
              })
            }
            columnDefs={TableHeadUnderThrInv}
            fullScreenView={fullScreenView}
            gridCall={onGridReady}
            handleFullScreenViewClick={handleFullScreenView}
            exportFile
            helpMessage=""
            data-testid="underThInv-grid"
            fileName="Under Threshold Invoices"
            singleClickEdit
            suppressCellFocus
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            onCellFocused={onCellFocused}
            frameworkComponents={{
              ActionCellRender: (cellInfo) => {
                const [hoverCC, setHoverCC] = React.useState(false);
                return (
                  <div
                    className="tdCell icon-btn-group"
                    data-testid="action-column"
                  >
                    {hoverCC ? (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="com-tooltip">Comment</Tooltip>}
                      >
                        <Button
                          onClick={() => {
                            setCorrLinkId(cellInfo.data?.corrLinkId);
                            setShowComments(true);
                            setHoverCC(false);
                          }}
                          tabIndex={'0'}
                          onKeyDown={(e) => {
                            // Handle Enter and Space key events
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault(); // Prevents the default space scrolling behavior
                              setCorrLinkId(cellInfo.data?.corrLinkId);
                              setShowComments(true);
                              setHoverCC(false);
                            }
                          }}
                          onMouseOver={() => setHoverCC(true)}
                          onMouseOut={() => setHoverCC(false)}
                          className={`th-ic comment-ic ${
                            parseInt(cellInfo.data.ccCommentsExist, [0, 1]) ===
                            1
                              ? 'frr-enabled-comment-btn'
                              : 'frr-disabled-comment-btn'
                          }`}
                          variant="text"
                        >
                          {parseInt(cellInfo.data.ccCommentsExist, [0, 1]) ===
                          1 ? (
                            <img alt="comment" src={CommentVisibleIcon} />
                          ) : (
                            <img alt="comment" src={CommentIcon} />
                          )}
                        </Button>
                      </OverlayTrigger>
                    ) : (
                      <Button
                        onClick={() => {
                          setCorrLinkId(cellInfo.data?.corrLinkId);
                          setShowComments(true);
                          setHoverCC(false);
                        }}
                        tabIndex={'0'}
                        onKeyDown={(e) => {
                          // Handle Enter and Space key events
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault(); // Prevents the default space scrolling behavior
                            setCorrLinkId(cellInfo.data?.corrLinkId);
                            setShowComments(true);
                            setHoverCC(false);
                          }
                        }}
                        onMouseOver={() => setHoverCC(true)}
                        onMouseOut={() => setHoverCC(false)}
                        className={`th-ic comment-ic ${
                          parseInt(cellInfo.data.ccCommentsExist, [0, 1]) === 1
                            ? 'frr-enabled-comment-btn'
                            : 'frr-disabled-comment-btn'
                        }`}
                        variant="text"
                      >
                        {parseInt(cellInfo.data.ccCommentsExist, [0, 1]) ===
                        1 ? (
                          <img alt="comment" src={CommentVisibleIcon} />
                        ) : (
                          <img alt="comment" src={CommentIcon} />
                        )}
                      </Button>
                    )}
                    <Dropdown className="icon-dropdown-container">
                      <Dropdown.Toggle
                        className="icon-dropdown export_wrap"
                        aria-label="export"
                      >
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="action-tooltip">Actions</Tooltip>
                          }
                        >
                          <SVGComponent iconName="Icon-export1" />
                        </OverlayTrigger>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="export_dropdown">
                        <Dropdown.Item
                          role="button"
                          data-testid="viewInvoice"
                          onClick={() => {
                            handleViewDetailsForInvoiceDetail(cellInfo.data);
                          }}
                        >
                          Go to Invoice
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                );
              },
              nameRenderMFG: (cellInfo) => {
                const name = cellInfo?.data?.mfgName;
                if (name && name.length > 24) {
                  return (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                    >
                      <div>{name && `${name.substring(0, 24)}...`}</div>
                    </OverlayTrigger>
                  );
                }
                return <div>{name}</div>;
              },
              InvoiceHandlingCdCellRender: (cellInfo) => {
                return (
                  <SelectBoxRender
                    {...cellInfo}
                    isReadOnly={isReadOnly}
                    dropdownListForHandingCode={
                      commonDropdownList?.INVOICE_HANDLING_CD
                    }
                  />
                );
              },
              RetainedAmtCellRender: (cellInfo) => {
                const isNegativeVal = !(
                  parseFloat(
                    cellInfo?.data?.retainedAmount?.toString().split('$')[1]
                  ) >= 0
                );
                return (
                  <>
                    {isNegativeVal ? (
                      <div
                        style={{ color: RedColor }}
                      >{`(${cellInfo?.data?.retainedAmount
                        ?.toString()
                        ?.replace('-', '')
                        .trim()})`}</div>
                    ) : (
                      <div>{`${cellInfo?.data?.retainedAmount}`}</div>
                    )}
                  </>
                );
              },
              CurrentInvoicedAmtCellRender: (cellInfo) => {
                const isNegativeVal = !(
                  parseFloat(
                    cellInfo?.data?.totCurrQtrAmt?.toString().split('$')[1]
                  ) >= 0
                );
                return (
                  <>
                    {isNegativeVal ? (
                      <div
                        style={{ color: RedColor }}
                      >{`(${cellInfo?.data?.totCurrQtrAmt
                        ?.toString()
                        ?.replace('-', '')
                        .trim()})`}</div>
                    ) : (
                      <div>{`${cellInfo?.data?.totCurrQtrAmt}`}</div>
                    )}
                  </>
                );
              },
              AccumulatedTotalCellRender: (cellInfo) => {
                const isNegativeVal = !(
                  parseFloat(
                    cellInfo?.data?.accumulatedTotal?.toString().split('$')[1]
                  ) >= 0
                );
                return (
                  <>
                    {isNegativeVal ? (
                      <div
                        style={{ color: RedColor }}
                      >{`(${cellInfo?.data?.accumulatedTotal
                        ?.toString()
                        ?.replace('-', '')
                        .trim()})`}</div>
                    ) : (
                      <div>{`${cellInfo?.data?.accumulatedTotal}`}</div>
                    )}
                  </>
                );
              },
            }}
          />
        )}
      </div>
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName="INVOICE_HEADER"
          corrLinkId={corrLinkId}
          rowGridPrimaryKey={null}
        />
      ) : null}
    </div>
  );
}
export default DisplayUnderThresholdInvoices;
